import { SIGNUP_SEGMENT_PROPERTIES_KEY } from "./constants";
import { updateLocalStorage } from "./local-storage";

(function(){

  const WRITE_KEY_DEV = 'GzxLVReekc5XLtIoZHW0VzUCJruriUe9';
  const WRITE_KEY_STAGE = '2ETwUyTygB2mj5QNUvr6Fcfn3DzEKx4X';
  const WRITE_KEY_PROD = 'vQNeEUkC3ieQ65ljR7oeYzybrpVBx53o';
  const SNIPPET_VERSION = '4.15.2';
  const ENV_PROD = 'prod';
  const ENV_STAGE = 'stage';
  const ENV_DEV = 'dev';
  const ENV_LOCAL = 'local';

  const getWriteKey = () => {
      const environment = window.twilio.environment || ENV_STAGE;
      switch (environment) {
          case ENV_PROD:
              return WRITE_KEY_PROD;
          case ENV_DEV:
              return WRITE_KEY_DEV;
          case ENV_LOCAL:
              return WRITE_KEY_DEV;
          default:
              return WRITE_KEY_STAGE;
      }
  }

  // Segment Analytics Js
  // Create a queue, but don't obliterate an existing one!
  var analytics = window.analytics = window.analytics || [];
  // If the real analytics.js is already on the page return.
  if (analytics.initialize) return;
  // If the snippet was invoked already show an error.
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.');
    }
    return;
  }
  // Invoked flag, to make sure the snippet
  // is never invoked twice.
  analytics.invoked = true;
  // A list of the methods in Analytics.js to stub.
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
    'addSourceMiddleware',
    'addIntegrationMiddleware',
    'setAnonymousId',
    'addDestinationMiddleware'
  ];
  // Define a factory to create stubs. These are placeholders
  // for methods in Analytics.js so that you never have to wait
  // for it to load to actually record data. The `method` is
  // stored as the first argument, so we can replay the data.
  analytics.factory = function(method){
    return function(){
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  // For each of our methods, generate a queueing stub.
  for (var i = 0; i < analytics.methods.length; i++) {
    var key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }
  // Define a method to load Analytics.js from our CDN,
  // and that will be sure to only ever load it once.
  analytics.load = function(key, options){
    // Create an async script element based on your key.
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://cdn.segment.com/analytics.js/v1/'
        + key + '/analytics.min.js';
    // Insert script next to the first script element.
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
    analytics._loadOptions = options;
  };

  const writeKey= getWriteKey();

  analytics._writeKey = writeKey;

  analytics.SNIPPET_VERSION = SNIPPET_VERSION;

  analytics.load(writeKey);

  function getUrlSearchParams() {
    const locationSearch = window.location.search;
    const searchParams = new URLSearchParams(locationSearch);
    const queryMap = {};
    for (const [key, value] of searchParams.entries()) {
      queryMap[key] = value;
    }
    return queryMap;
  }

  // https://segment.com/docs/connections/spec/page/#properties
  // https://segment.com/docs/guides/how-to-guides/cross-channel-tracking/
  function getSignupSegmentProperties() {
      const searchParams = getUrlSearchParams();
      return {
          "path" : location.pathname,
          "referrer" : document.referrer,
          "search" : location.search,
          "title" : document.title,
          "url" : location.href,
          "utm_campaign" : searchParams["utm_campaign"] || "",
          "utm_medium" : searchParams["utm_medium"] || "",
          "utm_source" : searchParams["utm_source"] || "",
          "utm_term" : searchParams["utm_term"] || "",
      }
  }

  updateLocalStorage(SIGNUP_SEGMENT_PROPERTIES_KEY, getSignupSegmentProperties());
})();



// WEBPACK FOOTER //
// ./src/js/segment-analytics.js